<template>
  <div class="nominations" :class="{'nominations_full-width': fullWidth}">
    <div class="nominations__info" :class="{'nominations__info_no-tabs': tabs.length <= 1}">
      <div class="info__image" :style="`background-image: url('${image}');`">
      </div>
      <div class="info__text">
        <div class="info__title" v-html="title"></div>
      </div>
      <div class="info__tabs">
        <Tabs 
          v-if="tabs.length > 1"
          :items="tabs"
          :activeItem="selectedTab"
          @changed="onTabChanged"
        />
      </div>
    </div>
    <div class="nominations__items">
      <div 
        class="items__slider" 
        :style="{
          'opacity': (hiddenSlider ? '0' : '1'),
          'min-height': (itemsSliderHeight ? itemsSliderHeight + 'px' : 'auto'),
        }"
        :id="itemsSliderId"
      >
        <Slider 
          v-if="!updating"
          :cols="cols"
          :navigationOffset="navigationOffset"
          :paginationOffset="paginationOffset"
          :filterByGroupId="selectedTab.toString()"
          :loop="loop"
        >
          <slot></slot>
        </Slider>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from '@rr-component-library/tabs/src/main';
import Slider from '@sc-component-library/slider/src/main';

export default {
  name: 'Nominations',
  designVersion: '1.0.0',
  components: {
    Tabs,
    Slider,
  },
  props: {
    /**
     * Изображение
     */
    image: {
      type: String,
    },
    /**
     * Текст заголовка
     */
    title: {
      type: String,
    },
    /**
     * Массив со свойствами вкладок (tabs)<br>
     * `[ { title: 'Участники', enabled: true }, ... ]`<br>
     * поле `title` - текст названия вкладки<br>
     * поле `enabled` - доступна вкладка или нет
     */
    tabs: {
      type: Array,
    },
    /**
     * Выбранная по умолчанию вкладка (tab)
     */
    activeTab: {
      type: [String, Number],
      default: 0,
    },
    /**
     * Область контента на всю ширину или 1024px
     */
    fullWidth: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedTab: this.$props.activeTab,
      updating: false,
      hiddenSlider: false,
      itemsSliderId: `items__slider${Math.random().toString().replace('.', '')}`,
      itemsSliderHeight: 0,
    };
  },
  computed: {
    cols() {
      return { default: '1', lg: '2', xl: '2' };
    },
    navigationOffset() {
      return { default: '0', md: '72', lg: '72', xl: '84' };
    },
    paginationOffset() {
      return { default: '28', md: '44', lg: '44', xl: '60' };
    },
    loop() {
      return true;
    },
  },
  watch: {
    updating(val) {
      if (val) this.hiddenSlider = true;
      else setTimeout(() => { 
        this.itemsSliderHeight = 0;
        this.hiddenSlider = false;
      }, 500);
    }
  },
  methods: {
    onTabChanged(index) {
      this.updateHeight();
      setTimeout(() => { this.updating = true; }, 100);
      setTimeout(() => { 
        this.selectedTab = index;
        this.updating = false; 
      }, 400);
    },
    updateHeight() {
      const itemsSlider = document.getElementById(this.itemsSliderId);
      if (itemsSlider === null) return;
      if (itemsSlider.offsetHeight > 0) {
        this.itemsSliderHeight = itemsSlider.offsetHeight;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./Nominations";
</style>
